import Swagger from '@/common/utils/swagger.js';
import * as Constants from '@/common/utils/constants';
import * as Messages from '@/common/utils/messages';
import * as Tools from '@/common/utils/tools';

export default {
  data() {
    return {
      perpetual: Constants,
      // 展示支付结果弹窗
      exhibitionPayResult: false,
      payResultParams: {}
    };
  },
  methods: {
    /*
    通用调用医生信息方法
    item[object]：医生信息
    params[object]：后续传参
    */
    async homepage_mixin_getDoctorInfoByCondition(item = {}, params = {}) {
      // 格式化处理下述调用医生信息出参格式
      const SendBack = (result) => {
        const fructify = {
          code: 1,
          msg: '',
          data: []
        };
        if (result) {
          if (result.code === 0) {
            if (result.data && result.data.length > 0) {
              fructify.code = 0;
              fructify.data = result.data;
            }
            else fructify.msg = Messages.APPOINT002;
          }
          else fructify.msg = result.msg;
        }
        else fructify.msg = Messages.C001;
        return fructify;
      };
      // 调用院内医生信息
      const BasicInfo = () => {
        return new Promise(resolve => {
          this.$sn.utils.ordinaryRequest({
            url: Swagger.getBasicDoctorInfoByCondition,
            // 不传递科室 ID
            query: {
              hosId: this.$sn.utils.getHospitalId(),
              doctorId: item.doctorId || item.docId
            },
            header: true
          }).then(result => {
            resolve({
              sort: 1,
              ...SendBack(result)
            });
          });
        });
      };
      // 调用互联网医院院内医生扩展信息
      const BasicOnlineExtend = () => {
        return new Promise(resolve => {
          this.$sn.utils.ordinaryRequest({
            url: Swagger.getBasicOnlineDoctorExtendInfoByCondition,
            // 不传递科室 ID
            query: {
              hosId: this.$sn.utils.getHospitalId(),
              doctorId: item.doctorId || item.docId
            },
            header: true
          }).then(result => {
            resolve({
              sort: 2,
              ...SendBack(result)
            });
          });
        });
      };
      // 调用单点医院业务医生信息
      const OfflineInfo = () => {
        return new Promise(resolve => {
          this.$sn.utils.ordinaryRequest({
            url: Swagger.getOfflineDoctorInfoByCondition,
            // 最大限度传入医生信息，尽可能缩小查询范围
            query: {
              hosId: this.$sn.utils.getHospitalId(),
              hosArea: item.hosArea || item.areaId || this.$sn.utils.getHospitalAreaId(),
              businessType: item.businessType || this.perpetual.BASIC_BUSINESS_OFFLINE_CKQBYS,
              deptId: item.deptId || item.departId || '',
              doctorId: item.doctorId || item.docId || ''
            },
            header: true
          }).then(result => {
            resolve({
              sort: 3,
              ...SendBack(result)
            });
          });
        });
      };
      // 调用互联网医院业务医生信息
      const OnlineInfo = () => {
        return new Promise(resolve => {
          this.$sn.utils.ordinaryRequest({
            url: Swagger.getOnlineDoctorInfoByCondition,
            // 最大限度传入医生信息，尽可能缩小查询范围
            query: {
              hosId: this.$sn.utils.getHospitalId(),
              doctorId: item.doctorId || item.docId || '',
              businessType: item.businessType,
              hosArea: item.hosArea || item.areaId || this.$sn.utils.getHospitalAreaId(),
              deptId: item.deptId || item.departId || ''
            },
            header: true
          }).then(result => {
            resolve({
              sort: 3,
              ...SendBack(result)
            });
          });
        });
      };
      let result1 = {}; // 承接第一个接口调用返回
      let result2 = {}; // 承接第二个接口调用返回
      if (this.$sn.validate.empty(params.type)) this.$set(params, 'type', 'offline');
      /*
      第一个接口调用单点医院业务医生信息需满足以下条件
      1）当前调用场景为单点医院
      2）传递了业务类型
      */
      if (params.type === 'offline' && item.businessType) {
        result1 = await OfflineInfo();
      }
      /*
      第一个接口调用调用互联网医院业务医生信息需满足以下条件
      1）当前调用场景为互联网医院
      2）传递了业务类型
      3）当前医院调取医生信息时需使用科室进行限制
      */
      else if (params.type === 'online' && item.businessType && this.$sn.getConfig('onlineDoctorBusinessRestrictDepart')) {
        result1 = await OnlineInfo();
        // 此场景下无需再进行任何信息的补全逻辑，直接返回
        return result1;
      }
      // 除上述两种调用方式外，第一个接口均调用院内医生信息
      else {
        result1 = await BasicInfo();
      }
      // 如第一个接口调用成功则继续后续逻辑，否则直接返回
      if (result1.code === 0) {
        /*
        1）当前调用场景为单点医院
        2）医生主页不展示其他场景功能
        满足上述条件，直接使用第一个接口调用返回
        */
        if (params.type === 'offline' && !this.$sn.getConfig('offlineDoctorHomepageExhibitionExtra')) {
          return result1;
        }
        else {
          // 调用互联网医院院内医生扩展信息进行补全
          result2 = await BasicOnlineExtend();
          // 如第二个接口调用成功则继续后续逻辑，否则直接返回第一个接口信息
          if (result2.code === 0) {
            /*
            整合两个接口返回
            按照上述单个调用医生信息方法中 sort 进行排序，以此作为后续字段补全优先级
            补全优先级：院内医生信息 < 互联网医院院内医生扩展信息 < 业务医生信息
            */
            const handle = this.$sn.format.digitalSort([result1, result2]);
            let fructify = handle[0].data;
            handle.slice(1).forEach(el => {
              // 如当前待补全项中无科室 ID，则直接将首项取出后，以补全信息为打底，进行补全
              if (!this.$sn.validate.empty(fructify.find(result => !result.deptId))) {
                el.data.forEach((doctor, i) => {
                  el.data[i] = {
                    ...fructify[0],
                    ...doctor
                  };
                });
                fructify = el.data;
              }
              else {
                fructify.forEach((doctor, i) => {
                  const match = el.data.find(result => !result.deptId || result.deptId === doctor.deptId);
                  if (!this.$sn.validate.empty(match)) {
                    fructify[i] = {
                      ...doctor,
                      ...match
                    };
                  }
                });
              }
            });
            return {
              code: 0,
              msg: '',
              data: fructify
            };
          }
          else return result1;
        }
      }
      else return result1;
    },
    /*
    type[string]：功能标识
    patient[object]：就诊人信息
    cost[integer/string]：待支付全额
    gap[integer/string]：待支付差额
    reg[string]：支付方式
    item[object]：业务功能信息
    params[object]：支付框展示业务信息
      func[string]：功能 ID
      title[string]：扫码支付标题
      sub[string]：扫码支付副标题
      label[string]：功能标识文案
      interaction[object]：确认按钮配置信息
        text[string]：确认按钮文案
        disabled[boolean]：未完成支付前确认按钮是否可点击
        func[function]：点击调用方法
      swagger[object]：充值成功后后续调用接口信息
    */
    async homepage_mixin_rechargeTransit(storage) {
      this.$sn.assembly.loading(true);
      await Tools.getHospitalConfigInformation([
        this.perpetual.CONFIG_TYPE_RECHARGE
      ]);
      const label = this.$sn.getConfig('outRechargeLabel');
      const {
        patient
      } = storage;
      const verifyCard = () => {
        return new Promise(resolve => {
          this.$sn.utils.ordinaryRequest({
            url: Swagger.verifyCard,
            method: 'POST',
            header: true,
            data: JSON.stringify({
              cardNo: patient.outCardNo,
              cardType: this.perpetual.OUT_CARD_CLINIC_TYPE,
              hosId: this.$sn.utils.getHospitalId(),
              patId: patient.patientId,
              payType: '1',
              platformId: this.$sn.utils.getPlatformType(),
              platformUserId: this.$sn.utils.getOpenId()
            })
          }).then(result => {
            const fructify = {
              code: 0,
              msg: ''
            };
            if (result) {
              if (result.code === 0) {
                if (result.data && this.$sn.validate.json(result.data)) {
                  if (JSON.parse(result.data).ResultCode !== '0') {
                    fructify.code = 4;
                    fructify.msg = this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL ? '未查询到门诊卡信息。' : (JSON.parse(result.data).ResultMsg || Messages.C001);
                  }
                }
                else {
                  fructify.code = 3;
                  fructify.msg = Messages.C002;
                }
              }
              else {
                fructify.code = 2;
                fructify.msg = result.msg;
              }
            }
            else {
              fructify.code = 1;
              fructify.msg = Messages.C001;
            }
            resolve(fructify);
          });
        });
      };
      const getBalance = () => {
        return new Promise(resolve => {
          this.$sn.utils.ordinaryRequest({
            url: Swagger.getCardBalance,
            method: 'POST',
            header: true,
            data: JSON.stringify({
              bindType: this.$sn.utils.getPlatformType(),
              cardNo: patient.outCardNo,
              clinicType: this.perpetual.OUT_CARD_CLINIC_TYPE,
              hosArea: '',
              hosId: this.$sn.utils.getHospitalId(),
              idCardNo: '',
              openId: this.$sn.utils.getOpenId(),
              patName: '',
              patientId: patient.patientId,
              reservedDate: '',
              state: ''
            })
          }).then(result => {
            const fructify = {
              code: 0,
              msg: '',
              data: {}
            };
            if (result) {
              if (result.code === 0 && result.data && result.data.cardBalance) {
                fructify.data = result.data;
              }
              else {
                fructify.code = 2;
                fructify.msg = Messages.RECHARGE010;
              }
            }
            else {
              fructify.code = 1;
              fructify.msg = Messages.C001;
            }
            resolve(fructify);
          });
        });
      };
      const verifyTime = () => {
        const fructify = {
          code: 0,
          msg: ''
        };
        const startMinDate = this.$sn.format.date(new Date(), 'yyyy-MM-dd') + ' ' + this.$sn.getConfig('rechargeEndTime') + ':00';
        const startMaxDate = this.$sn.format.date(new Date(), 'yyyy-MM-dd', 1, 'day') + ' 00:00:00';
        const endMinDate = this.$sn.format.date(new Date(), 'yyyy-MM-dd') + ' 00:00:00';
        const endMaxDate = this.$sn.format.date(new Date(), 'yyyy-MM-dd') + ' ' + this.$sn.getConfig('rechargeStartTime') + ':00';
        const time = this.$sn.format.date(new Date(), 'yyyy-MM-dd HH:mm:ss');
        if ((time >= startMinDate && time <= startMaxDate) || (time >= endMinDate && time <= endMaxDate)) {
          fructify.code = 2;
          fructify.msg = label + '时间为每天' + this.$sn.getConfig('rechargeStartTime') + '-' + this.$sn.getConfig('rechargeEndTime') + '。';
        }
        return fructify;
      };
      const gapFormat = (digit) => {
        digit = digit.toString();
        const fructify = digit.split('.');
        if ((fructify[1] || '').length < 2) {
          fructify[1] = fructify[1] || '';
          fructify[1] += new Array(2 - fructify[1].length + 1).join('0');
        }
        return fructify.join('.');
      };
      const cb = () => {
        if (storage.type === 'appointment-record') {
          if (this.$route.path === '/appointment/confirm') {
            this.homepage_mixin_navigateUrl('/appointment/record-info', '', {
              id: storage.item.appointId
            }, 'replace');
          }
        }
      };
      const exhibition = (gap, serial, qr) => {
        this.payResultParams = {
          ...storage.params || {},
          cost: gap,
          pay: {
            [storage.reg]: {
              serial: serial,
              qr: qr
            }
          }
        };
        this.exhibitionPayResult = true;
      };
      if (this.$sn.getConfig('isRechargeVerifyOutCard') || this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL) {
        const verify = await verifyCard();
        if (verify.code !== 0) {
          this.$sn.assembly.loading(false);
          this.$sn.assembly.modal({
            caption: verify.msg,
            isCancel: false,
            success: (modal) => {
              if (modal.confirm) {
                cb();
              }
            }
          });
          return false;
        }
      }
      const balance = await getBalance();
      if (balance.code !== 0) {
        this.$sn.assembly.loading(false);
        this.$sn.assembly.modal({
          caption: balance.msg,
          isCancel: false,
          success: (modal) => {
            if (modal.confirm) {
              cb();
            }
          }
        });
        return false;
      }
      let gap = storage.gap ? parseFloat(storage.gap) : Math.round((parseFloat(storage.cost) - parseFloat(balance.data.cardBalance)) * 100) / 100;
      if (gap < 0) {
        this.$sn.assembly.loading(false);
        this.$sn.assembly.modal({
          caption: label + '金额不能小于0元',
          isCancel: false,
          success: (modal) => {
            if (modal.confirm) {
              cb();
            }
          }
        });
        return false;
      }
      if (this.$sn.getConfig('isRechargeVerifyOutCardBalance') && balance.data.operateState === '0') {
        let caption = '';
        if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SZY) {
          caption = '社保卡最大' + label + '金额为1500元，当前可' + label + '金额为';
          if (parseFloat(balance.data.cardBalance) >= this.$sn.getConfig('outCardBalanceRechargeRestrict')) {
            caption += '0。';
          }
          else {
            const permit = Math.round((this.$sn.getConfig('outCardBalanceRechargeRestrict') - parseFloat(balance.data.cardBalance)) * 100) / 100;
            if (parseFloat(gap) > permit) {
              caption += permit + '。';
            }
          }
        }
        else {
          const compare = {
            [this.perpetual.HOSPITAL_ID_YTS]: '该卡已停用或已挂失，暂时无法使用',
            [this.perpetual.HOSPITAL_ID_JNRM]: '暂不支持扶贫患者线上' + label + '！'
          };
          caption = compare[this.$sn.utils.getHospitalId()];
        }
        if (caption) {
          this.$sn.assembly.loading(false);
          this.$sn.assembly.modal({
            caption: caption,
            isCancel: false,
            success: (modal) => {
              if (modal.confirm) {
                cb();
              }
            }
          });
          return false;
        }
      }
      const time = await verifyTime();
      if (time.code !== 0) {
        this.$sn.assembly.loading(false);
        this.$sn.assembly.modal({
          caption: time.msg,
          isCancel: false,
          success: (modal) => {
            if (modal.confirm) {
              cb();
            }
          }
        });
        return false;
      }
      gap = gapFormat(gap);
      let primary = storage.reg;
      const ExtendInfo = {};
      let ip = '';
      if (this.$sn.utils.getSubRegType(storage.reg)) {
        this.$set(ExtendInfo, 'subPayType', this.$sn.utils.getSubRegType(storage.reg));
        if (this.$sn.utils.isYuanQi()) {
          this.$set(ExtendInfo, 'patId', patient.outCardId);
          this.$set(ExtendInfo, 'patName', patient.patientName);
          if (this.$sn.utils.getRegType() === this.perpetual.REG_TYPE_YUANQI2) {
            ip = await Tools.getIp();
          }
        }
        this.$set(ExtendInfo, 'busType', this.perpetual.PAY_BUSINESS_TYPE_OUT_RECHARGE);
        primary = this.$sn.utils.getRegType();
        console.log(ip);
      }
      let Subject = '就诊卡' + label;
      if (!this.$sn.validate.empty(this.$sn.getConfig('outRechargeSubjectLabel'))) {
        const label = [];
        this.$sn.getConfig('outRechargeSubjectLabel')[1].split(',').forEach(el => {
          if (el === 'outCardSerial') label.push(patient.outCardNo);
          else if (el.split('.').length > 1 && el.split('.')[0] === 'selectedPatient') {
            label.push(patient[el.split('.')[1]]);
          }
        });
        if (label.length > 0) Subject = this.$sn.format.caption(this.$sn.getConfig('outRechargeSubjectLabel')[0], label);
      }
      if (this.$sn.getConfig('pcUpdateRecharge')) {
        this.$sn.assembly.loading(true);
        this.$sn.utils.ordinaryRequest({
          url: Swagger.pcUpdateRechargeScanQR,
          method: 'POST',
          header: true,
          data: JSON.stringify({
            appId: this.$sn.utils.getHospitalId(),
            cardNo: patient.outCardNo,
            cardType: this.perpetual.OUT_CARD_CLINIC_TYPE,
            dataType: this.$sn.utils.getPlatformType(),
            extendInfo: this.$sn.validate.empty(ExtendInfo) ? '' : JSON.stringify(ExtendInfo),
            extendType: '',
            himServiceId: '',
            himServiceType: '',
            limitPay: this.$sn.getConfig('isRestrictCreditCardOutRecharge') ? '' : '0',
            openid: this.$sn.utils.getOpenId(),
            outTradeNo: '',
            pagePath: '',
            payAccountNo: this.$sn.getConfig('outRechargeMerchantSerial'),
            payType: primary,
            phoneNumber: patient.patientPhone,
            projectType: this.$sn.utils.getProjectType(),
            remark: '备注',
            serviceType: this.perpetual.SERVICE_TYPE_RECHARGE,
            subject: Subject,
            totalFee: gap,
            userId: patient.patientId,
            userName: patient.patientName
          })
        }).then(result => {
          if (result) {
            if (result.code === 0) {
              if (!this.$sn.validate.empty(result.data) && !this.$sn.validate.empty(result.data.outTradeNo) && !this.$sn.validate.empty(result.data.Data)) {
                this.$sn.utils.ordinaryRequest({
                  url: Swagger.storePaymentParameter,
                  method: 'POST',
                  data: JSON.stringify({
                    accountId: this.$sn.utils.getAccountId(),
                    cardNo: patient.outCardNo,
                    cardType: this.perpetual.OUT_CARD_CLINIC_TYPE,
                    dataType: this.$sn.utils.getPlatformType(),
                    deptId: '',
                    deptName: '',
                    doctorId: '',
                    doctorName: '',
                    extendInfo: this.$sn.validate.empty(ExtendInfo) ? '' : JSON.stringify(ExtendInfo),
                    extendType: '',
                    himServiceId: '',
                    himServiceType: '',
                    hosId: this.$sn.utils.getHospitalId(),
                    noticeType: this.perpetual.NOTICE_TYPE_OUT_RECHARGE,
                    outTradeNo: result.data.outTradeNo,
                    patientId: patient.patientId,
                    patientIdCard: patient.patientIdCardNo,
                    patientName: patient.patientName,
                    patientPhone: patient.patientPhone,
                    payAccountNo: this.$sn.getConfig('outRechargeMerchantSerial'),
                    payType: primary,
                    platformId: this.$sn.utils.getPlatformType(),
                    platformUserId: this.$sn.utils.getOpenId(),
                    projectType: this.$sn.utils.getProjectType(),
                    remark: '',
                    totalFee: gap
                  }),
                  reload: false
                }).then(res => {
                  this.$sn.assembly.loading(false);
                  if (res && res.code === 0 && res.data && res.data.ResultCode && (res.data.ResultCode === 0 || res.data.ResultCode === '0')) {
                    exhibition(gap, result.data.outTradeNo, result.data.Data);
                  }
                  else {
                    this.$sn.assembly.modal({
                      caption: Messages.RECHARGE002,
                      isCancel: false,
                      success: (modal) => {
                        if (modal.confirm) {
                          cb();
                        }
                      }
                    });
                  }
                });
              }
              else {
                this.$sn.assembly.loading(false);
                this.$sn.assembly.modal({
                  caption: this.$sn.validate.empty(result.data.outTradeNo) || this.$sn.validate.empty(result.data.Data) ? Messages.RECHARGE003 : Messages.C002,
                  isCancel: false,
                  success: (modal) => {
                    if (modal.confirm) {
                      cb();
                    }
                  }
                });
              }
            }
            else {
              this.$sn.assembly.loading(false);
              this.$sn.assembly.modal({
                caption: result.msg,
                isCancel: false,
                success: (modal) => {
                  if (modal.confirm) {
                    cb();
                  }
                }
              });
            }
          }
          else {
            this.$sn.assembly.loading(false);
            this.$sn.assembly.modal({
              caption: Messages.C001,
              isCancel: false,
              success: (modal) => {
                if (modal.confirm) {
                  cb();
                }
              }
            });
          }
        });
      }
      else {
        this.$sn.assembly.loading(true);
        this.$sn.utils.ordinaryRequest({
          url: Swagger.pcRechargeScanQR,
          method: 'POST',
          header: true,
          data: JSON.stringify({
            body: Subject,
            cardTypeCode: this.perpetual.OUT_CARD_CLINIC_TYPE,
            expand: '',
            hosId: this.$sn.utils.getHospitalId(),
            ip: '',
            patientCard: patient.outCardNo,
            patientCardId: patient.patientIdCardNo,
            patientId: patient.patientId,
            patientName: patient.patientName,
            patientPhone: patient.patientPhone,
            payType: primary,
            platformId: 'PCNYXH000S',
            serviceType: this.perpetual.SERVICE_TYPE_RECHARGE,
            terminalId: 'PCNYXH000S',
            totalFee: gap
          }),
          reload: false
        }).then(result => {
          this.$sn.assembly.loading(false);
          if (result) {
            if (result.code === 0) {
              if (result.data && this.$sn.validate.json(result.data)) {
                const res = JSON.parse(result.data);
                if (res.ResultCode === '0' && res.outTradeNo && res.Data) {
                  exhibition(res.outTradeNo, res.Data);
                }
                else {
                  this.$sn.assembly.modal({
                    caption: Messages.RECHARGE003,
                    isCancel: false,
                    success: (modal) => {
                      if (modal.confirm) {
                        cb();
                      }
                    }
                  });
                }
              }
              else {
                this.$sn.assembly.modal({
                  caption: Messages.RECHARGE003,
                  isCancel: false,
                  success: (modal) => {
                    if (modal.confirm) {
                      cb();
                    }
                  }
                });
              }
            }
            else {
              this.$sn.assembly.modal({
                caption: result.msg,
                isCancel: false,
                success: (modal) => {
                  if (modal.confirm) {
                    cb();
                  }
                }
              });
            }
          }
          else {
            this.$sn.assembly.modal({
              caption: Messages.C001,
              isCancel: false,
              success: (modal) => {
                if (modal.confirm) {
                  cb();
                }
              }
            });
          }
        });
      }
    },
    homepage_mixin_sendBackPayResult(type) {
      if (type) {}
      this.exhibitionPayResult = false;
      this.payResultParams = {};
    },
    async homepage_mixin_navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === '/appointment/doctor') {
        this.$sn.assembly.loading(true);
        const fructify = await this.homepage_mixin_getDoctorInfoByCondition(item, params);
        this.$sn.assembly.loading(false);
        if (fructify.code === 0) {
          this.$sn.utils.setHospitalLocalStorage('Appointment_DoctorInfo', fructify.data[0]);
          this.$router[type]({
            path: url,
            query: params || {}
          });
        }
        else {
          this.$sn.assembly.toast({
            caption: fructify.msg
          });
        }
      }
      else if (url.substring(0, 4) === 'http' || url.substring(0, 7) === '/static' || url.substring(0, 2) === '//') {
        window.open(url);
      }
      else {
        this.$router[type]({
          path: url,
          query: params || {}
        });
      }
    }
  }
};
